import { formatToDDMMYYYY } from "./utilityFunctions";

export const getEnquiryPayload = (storedData, formValues) => {

    const get = (key) => storedData[key] ?? formValues[key];
 const req= {
  "UserId": 0,
  "BusinessID": "",
  "LeadSource": "online",
  "MacId": "web",
  "SaveQuoteEnqRequestModel": {
    "MobileNo": get('mobileNo'),
    "StartDate": get('startDate'),
      "EndDate": get('endDate'),
      "Travelers": formValues.travellers,    //get('travellers'),
    "numberofDays": get('numberOfDays'),
    "Destination": get('destination')?.map(item => item.CountryName),
    "DestinationList": get('destination'),
    "enquiryNo": "",
    "policyType": "",
    "tripType": get('tripType'),
    "tripDuration": "",
    "SumAssured": 0,
    "LotNo": "",
    "InsurerID": null
  }
    }
    return req;
}


export const getQuotePayload = (params) => {
    const { quoteDetails } = params;
    const travellerDetails = params.requestData;
    const req = {
        "MobileNo": travellerDetails.mobileNo,
        "StartDate": formatToDDMMYYYY(travellerDetails.startDate),
        "EndDate": formatToDDMMYYYY(travellerDetails.endDate),
        "Travelers": travellerDetails.travellers,
        "numberofDays": travellerDetails.numberOfDays,
        "Destination": travellerDetails.destination.map(item => item.CountryName),
        "DestinationList": travellerDetails.destination,
        "enquiryNo": travellerDetails.enquiryNo,
        "policyType": travellerDetails.policyType,
        "tripType": travellerDetails.tripType,
        "tripDuration": travellerDetails.numberOfDays +'',
        "SumAssured": quoteDetails.filters.sumAssured,
        "LotNo": travellerDetails.lotNo,
        "InsurerID": ''
    };

    return req;
}


export const getShareQuoteProposalPayload = (params) => {
    const { travellerDetails, HiddenQuotes, ShareFor, values, shareOn,quote} = params;
    

    const body = {
        "UserID": 0,
        "TransKey": quote?.TransKey,
        "EnquiryNo": travellerDetails.enquiryNo,
        "ProductType": "TRV",
        "Stage": ShareFor === "PROPOSAL" ? "PROPOSAL" : "Quotation",
        "MobileNo": shareOn === 'sms' ? values.mobileNumber : "",
        "EmailID": shareOn === 'email' ? values.email : '',
        "HideInsurerIDs": HiddenQuotes,
        "OtherData": ""
    }

    return body;
}

export const genSharedQuotePayload = (params) => {
    return {
        "EnquiryNo": params.enquiryno,
        "Stage": "Quotation",
        "ShareID": params.shareid
    }
}